const LATIN_START = /^[a-z]/i;
const HEBREW_START = /^[֐-׿]/;

// Architectural summary: Sort bucket for the picker — Latin (0), Hebrew (1), digits/symbols (2).
const startBucket = (name: string): number => {
    const first = name.trim().charAt(0);
    if (LATIN_START.test(first)) return 0;
    if (HEBREW_START.test(first)) return 1;
    return 2;
};

// Architectural summary: Sorts picker names Latin (ci), then Hebrew, then digits/symbols.
export const compareEmployeeNames = (a: string, b: string): number => {
    const bucketA = startBucket(a);
    const bucketB = startBucket(b);
    if (bucketA !== bucketB) return bucketA - bucketB;
    if (bucketA === 0) return a.toLowerCase().localeCompare(b.toLowerCase(), 'en');
    if (bucketA === 1) return a.localeCompare(b, 'he');
    return a.localeCompare(b);
};

// Architectural summary: Returns a new list sorted by `compareEmployeeNames` on `fullName`.
export const sortEmployeesForPicker = <T extends { fullName: string }>(employees: readonly T[]): T[] =>
    [...employees].sort((a, b) => compareEmployeeNames(a.fullName, b.fullName));
